import { Button } from "../../common/Button";
import { Modal } from "../../common/Modal";

export function ConfirmModal({
  busy,
  confirmLabel,
  errorMessage,
  message,
  onClose,
  onConfirm,
  onSecondaryConfirm,
  secondaryBusy = false,
  secondaryConfirmLabel,
  secondaryTone = "neutral",
  title,
  tone,
}: {
  busy: boolean;
  confirmLabel: string;
  errorMessage: string | null;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
  onSecondaryConfirm?: () => void;
  secondaryBusy?: boolean;
  secondaryConfirmLabel?: string;
  secondaryTone?: "danger" | "neutral";
  title: string;
  tone: "danger" | "neutral";
}) {
  return (
    <Modal
      title={title}
      subtitle={message}
      widthClass="max-w-lg"
      onClose={onClose}
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="secondary" size="sm" onClick={onClose}>
            Cancel
          </Button>
          {secondaryConfirmLabel && onSecondaryConfirm && (
            <Button
              variant={secondaryTone === "danger" ? "danger" : "outline"}
              size="sm"
              loading={secondaryBusy}
              loadingText="Forcing…"
              onClick={onSecondaryConfirm}
            >
              {secondaryConfirmLabel}
            </Button>
          )}
          <Button
            variant={tone === "danger" ? "danger" : "outline"}
            size="sm"
            loading={busy}
            loadingText="Applying…"
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </div>
      }
    >
      <div className="space-y-2">
        {errorMessage && <ModalErrorBlock message={errorMessage} />}
        <div className="border border-amber-500/30 bg-amber-500/5 px-3 py-2 font-mono text-[10px] uppercase tracking-[0.16em] text-amber-700 dark:text-amber-300">
          Explicit operator confirmation required.
        </div>
      </div>
    </Modal>
  );
}

export function ModalErrorBlock({ message }: { message: string }) {
  return (
    <div className="border border-rose-500/40 bg-rose-500/10 px-3 py-2 font-mono text-[11px] text-rose-700 dark:text-rose-200">
      <span className="break-words">{message}</span>
    </div>
  );
}
